import React from 'react';
import { useNavigate } from 'react-router-dom';
import type { OrderBillingContext } from '../utils/orderInvoiceRules';

type Props = {
  billing: OrderBillingContext;
  compact?: boolean;
};

export const OrderBillingBanner: React.FC<Props> = ({ billing, compact }) => {
  const navigate = useNavigate();
  if (!billing.hasInvoice) return null;

  const isLocked = billing.lockLevel === 'financial_locked';
  const bg = isLocked ? '#fef2f2' : '#eff6ff';
  const border = isLocked ? '#fecaca' : '#bfdbfe';
  const titleColor = isLocked ? '#991b1b' : '#1e40af';
  const textColor = isLocked ? '#7f1d1d' : '#1e3a8a';

  return (
    <div
      style={{
        marginBottom: compact ? 12 : 20,
        padding: compact ? '12px 16px' : '16px 20px',
        background: bg,
        border: `1px solid ${border}`,
        borderRadius: 12,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 16,
        flexWrap: 'wrap',
      }}
    >
      <div style={{ flex: 1, minWidth: 220 }}>
        <div style={{ fontWeight: 700, color: titleColor, fontSize: compact ? 14 : 15 }}>
          {isLocked ? '🔒 Invoiced — amounts locked' : '🧾 Invoiced — edit the invoice for prices'}
        </div>
        <div style={{ fontSize: 13, color: textColor, marginTop: 6, lineHeight: 1.5 }}>
          {billing.orderEditHint}
        </div>
        {!compact && (
          <div style={{ fontSize: 12, color: textColor, marginTop: 8, opacity: 0.9 }}>
            Rule: <strong>Order</strong> = fulfilment &amp; status · <strong>Invoice</strong> = money · <strong>Credit note</strong> = corrections after payment
          </div>
        )}
      </div>
      {billing.invoiceId && (
        <button
          type="button"
          onClick={() => navigate(`/invoices/view/${billing.invoiceId}`)}
          style={{
            padding: '10px 18px',
            background: '#6366f1',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            fontWeight: 700,
            fontSize: 13,
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}
        >
          Open {billing.invoiceNumber}
        </button>
      )}
    </div>
  );
};

export default OrderBillingBanner;
